import Header from "../components/Header";
import { useEffect, useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { collection, doc, query, where, orderBy, onSnapshot } from "firebase/firestore";
import { firestore } from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";
import { LuMessageCircle } from "react-icons/lu";
import { MdOutlineEmail } from "react-icons/md";
import { MdOutlineMail, MdOutlineSubject } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import { BiMessageSquareDetail, BiMap } from "react-icons/bi";
import { IoLocationOutline, IoTimeOutline } from "react-icons/io5";
import Footer from "../components/Footer";


export default function Contato() {
    const [revenda, setRevenda] = useState([])
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [assunto, setAssunto] = useState('');
    const [msgEnviado, setMsgEnviado] = useState('');
    const [enviado, setEnviado] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);

        const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
        revendaRef &&
            firestore.getDoc
            ? firestore.getDoc(revendaRef).then((docSnap) => {
                if (docSnap.exists()) {
                    setRevenda(docSnap.data());
                }
            })
            : import("firebase/firestore").then(({ getDoc }) =>
                getDoc(revendaRef).then((docSnap) => {
                    if (docSnap.exists()) {
                        setRevenda(docSnap.data());
                    }
                })
            );

        const q = query(
            collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
            where("veremovido", "==", 0),
            where("vevendido", "==", 0),
            orderBy("updated_at", "desc")
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const items = [];
            querySnapshot.forEach((doc) => {
                const document = doc.data();
                document.id = doc.id;
                if (document["veexibir_site"] !== false) {
                    items.push(document);
                }
            });
        });

        return () => unsubscribe();
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!validateForm()) return;
        setEnviado(true);
        setMsgEnviado('Enviando mensagem...');

        let corpoMensagem = `<strong>Mensagem:</strong>`;
        corpoMensagem += `<br><br><strong>Dados pessoais</strong><br>`;
        corpoMensagem += `<br>Nome: ${nome}`;
        corpoMensagem += `<br>Email: ${email}`;
        corpoMensagem += `<br>Assunto: ${assunto}`;
        corpoMensagem += `<br>Mensagem: ${mensagem}`;

        fetch('https://us-central1-intermedio-1513801146022.cloudfunctions.net/enviarEmail', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                remetente: `Contato ${revenda.penome_fantasia}<${revenda.peemail}>`,
                assunto: `Mensagem - Site ${revenda.penome_fantasia} - ${assunto}`,
                destinatarios: revenda.peemail,
                corpo: corpoMensagem,
                corpoHtml: corpoMensagem,
            }),
        })
            .then((res) => {
                setMsgEnviado('E-mail enviado com sucesso! Em breve você receberá um retorno da nossa equipe.');
                setTimeout(() => setEnviado(false), 5000);
                resetForm();
            })
            .catch((error) => {
                setMsgEnviado('Erro ao enviar e-mail, tente novamente mais tarde.');
                setTimeout(() => setEnviado(false), 5000);
                console.error('Erro ao enviar e-mail:', error);
            });
    };

    const resetForm = () => {
        setNome('');
        setEmail('');
        setMensagem('');
        setAssunto('');
        setErrors({});
    };

    const validateForm = () => {
        const newErrors = {};
        if (!nome.trim()) newErrors.nome = "Nome obrigatório.";
        if (!mensagem.trim()) newErrors.mensagem = "Mensagem obrigatória.";
        if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) newErrors.email = "E-mail inválido.";
        if (!assunto.trim() || assunto === "Selecione um assunto") newErrors.assunto = "Assunto obrigatório.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <div>
            <Header />

            <div className="relative h-[450px] w-full">
                <img
                    src="/banner.png"
                    alt="Banner Maverick Motors II"
                    className="object-cover w-full h-full"
                />

                <div className="absolute inset-0 bg-black/50" />

                <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
                    <h1 className="text-2xl md:text-6xl font-bold mt-20">Entre em Contato</h1>
                    <p className="text-lg font-semibold mt-2">Estamos aqui para ajudar você a encontrar o veículo perfeito ou esclarecer suas dúvidas</p>
                </div>
            </div>

            <div className="flex flex-col md:flex-row justify-center items-center gap-6 p-4 mt-20">
                <div className="bg-secondary rounded-xl shadow-md p-6 w-full max-w-sm flex flex-col items-center text-center">
                    <div className="bg-card p-4 rounded-full mb-4">
                        <FaPhoneAlt className="text-primary text-2xl" />
                    </div>
                    <h2 className="text-primary font-bold text-xl mb-1">WhatsApp</h2>
                    
                    <h2 className="font-bold text-base mb-1 mt-4">
                        {retiraMascara(revenda.petelefone1)}
                    </h2>
                    <p className="text-sm text-muted-foreground">Atendimento 24h</p>
                </div>

                <div className="bg-secondary rounded-xl shadow-md p-6 w-full max-w-sm flex flex-col items-center text-center">
                    <div className="bg-card p-4 rounded-full mb-4">
                        <LuMessageCircle className="text-primary text-2xl" />
                    </div>
                    <h2 className="text-primary font-bold text-xl mb-1">WhatsApp e Telefone Fixo</h2>
                    <h2 className="font-bold text-base mb-1 mt-4">
                        {retiraMascara(revenda.petelefone2)}
                    </h2>
                    <p className="text-sm text-muted-foreground">Atendimento Horário Comercial</p>
                </div>

                <div className="bg-secondary rounded-xl shadow-md p-6 w-full max-w-sm flex flex-col items-center text-center">
                    <div className="bg-card p-4 rounded-full mb-4">
                        <MdOutlineEmail className="text-primary text-2xl" />
                    </div>
                    <h2 className="text-primary font-bold text-xl mb-1">E-mail</h2>
                    <h2 className="font-bold text-base mb-1 mt-4">
                        {revenda.peemail}
                    </h2>
                    <p className="text-sm text-muted-foreground">Resposta em até 24h</p>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-6 bg-card rounded-xl mt-20">
                <div className="bg-secondary rounded-xl shadow-md p-6">
                    <div className="flex items-center gap-2 mb-6">
                        <BiMessageSquareDetail className="text-primary text-2xl" />
                        <h2 className="text-primary font-bold text-lg uppercase">
                            Envie sua mensagem
                        </h2>
                    </div>

                    {msgEnviado && (
                        <div className={`mb-4 text-center font-semibold ${enviado ? 'text-primary' : 'text-primary'}`}>
                            {msgEnviado}
                        </div>
                    )}

                    <form className="space-y-4" onSubmit={handleSubmit}>

                        <div className="absolute -left-40 top-1/2 -translate-y-1/2 w-80 h-80 border border-primary/10 rounded-full" />
                        <div className="absolute -left-20 top-1/2 -translate-y-1/2 w-40 h-40 border border-primary/20 rounded-full" />
                        <div>
                            <label className="items-center flex text-sm font-medium mb-1 gap-2">
                                <FaUser className="inline-block mr-1 text-primary" />
                                Nome Completo *
                            </label>
                            <input
                                type="text"
                                placeholder="Digite seu nome completo"
                                className={`w-full border ${errors.nome ? 'border-primary' : 'border-border'} rounded-lg p-3 focus:ring-2 focus:ring-primary outline-none shadow-sm`}
                                value={nome}
                                onChange={e => setNome(e.target.value)}
                            />
                            {errors.nome && <span className="text-primary text-xs">{errors.nome}</span>}
                        </div>

                        <div>
                            <label className="flex items-center text-sm font-medium mb-1 gap-2">
                                <MdOutlineMail className="inline-block mr-1 text-primary" />
                                E-mail *
                            </label>
                            <input
                                type="email"
                                placeholder="seu@email.com"
                                className={`w-full border ${errors.email ? 'border-primary' : 'border-border'} rounded-lg p-3 focus:ring-2 focus:ring-primary outline-none shadow-sm`}
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                            {errors.email && <span className="text-primary text-xs">{errors.email}</span>}
                        </div>

                        <div>
                            <label className="flex items-center text-sm font-medium mb-1 gap-2">
                                <MdOutlineSubject className="inline-block mr-1 text-primary" />
                                Assunto *
                            </label>
                            <select
                                className={`w-full border ${errors.assunto ? 'border-primary' : 'border-border'} rounded-lg p-3 focus:ring-2 focus:ring-primary outline-none shadow-sm`}
                                value={assunto}
                                onChange={e => setAssunto(e.target.value)}
                            >
                                <option className="text-foreground">Selecione um assunto</option>
                                <option className="text-foreground">Orçamento</option>
                                <option className="text-foreground">Agendamento</option>
                                <option className="text-foreground">Dúvidas</option>
                            </select>
                            {errors.assunto && <span className="text-primary text-xs">{errors.assunto}</span>}
                        </div>

                        <div>
                            <label className="flex items-center text-sm font-medium mb-1 gap-2">
                                <BiMessageSquareDetail className="inline-block mr-1 text-primary" />
                                Mensagem *
                            </label>
                            <textarea
                                placeholder="Digite sua mensagem aqui..."
                                className={`w-full h-32 border ${errors.mensagem ? 'border-primary' : 'border-border'} rounded-lg p-3 resize-none focus:ring-2 focus:ring-primary outline-none shadow-sm`}
                                value={mensagem}
                                onChange={e => setMensagem(e.target.value)}
                            />
                            {errors.mensagem && <span className="text-primary text-xs">{errors.mensagem}</span>}
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold py-3 rounded-lg shadow-md flex items-center justify-center gap-2 transition"
                            disabled={enviado}
                        >
                            <BiMessageSquareDetail className="text-lg" />
                            ENVIAR MENSAGEM
                        </button>
                    </form>
                </div>

                <div className="space-y-4">

                    <div className="bg-secondary rounded-xl shadow-md p-6">
                        <div className="flex items-center gap-2 mb-4 ">
                            <div className="bg-card p-2 rounded-xl">
                                <BiMap className="text-primary text-2xl" />
                            </div>
                            <h2 className="text-primary font-bold text-xl">
                                Nossa Localização
                            </h2>
                        </div>

                        <div className="mb-3">
                            <p className="flex items-start gap-1 text-sm mb-1">
                                <IoLocationOutline className="text-primary mt-1 text-lg" />
                                <span>
                                    <strong className="text-foreground">Endereço:</strong><br />
                                    {revenda.peendereco_fiscal}, {revenda.peendereco_fiscal_numero} – {revenda.pebairro_fiscal} - {revenda.pecidade} - {revenda.peuf}
                                </span>
                            </p>
                        </div>

                        <div>
                            <p className="flex items-start gap-1 text-sm">
                                <IoTimeOutline className="text-primary mt-1 text-lg" />
                                <span>
                                    <strong className="text-foreground">Horário de Funcionamento:</strong><br />
                                    Segunda à Sexta: 8:00 às 18:00<br />
                                    Sábado: 8:00 às 12:00<br />
                                    Domingo: Fechado
                                </span>
                            </p>
                        </div>
                    </div>

                    <div className="bg-card rounded-xl shadow-md overflow-hidden">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1826.3468185227814!2d-46.54888564310571!3d-23.722632089076676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce419bd4d45053%3A0x8100463ee4f1ec90!2sR.%20Mal.%20Deodoro%2C%202785%20-%20Centro%2C%20S%C3%A3o%20Bernardo%20do%20Campo%20-%20SP%2C%2009710-193!5e0!3m2!1spt-BR!2sbr!4v1787011293794!5m2!1spt-BR!2sbr"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            className="w-full h-64"
                            title="Localização da Maverick Motors II"
                        />
                    </div>

                    <p className="text-center text-sm text-primary font-medium">
                        📍 Clique no mapa para abrir no Google Maps
                    </p>
                </div>
            </div>

            <Footer />
        </div>
    )
}
